import { useBranding } from '~src/context/BrandingContext';

import { Slider as SliderCommon } from './common';
import { Wrapper, WrapperNorlys } from './style';
import { SliderProps } from './types';

export const Slider = ({ size, style, ...rest }: SliderProps) => {
  const { lightColor: color } = useBranding();
  return (
    <Wrapper {...{ size, style, color }}>
      <SliderCommon {...rest} />
    </Wrapper>
  );
};

export const SliderNorlys = ({ size, style, ...rest }: SliderProps) => (
  <WrapperNorlys {...{ size, style }}>
    <SliderCommon {...rest} />
  </WrapperNorlys>
);
